import "./Login.css";
import logo from "../../Assets/Images/Logo.png";
import TextField from "../../Components/TextField/TextField";
import Button from "../../Components/Button/Button";
import Zoom from "react-reveal/Zoom";
import { useState } from "react";
import { PublicGet } from "../../Services/Server";
import Url from "../../Services/Url";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import User from "../../Services/User";
import { setNav } from "../../Components/NavMenu/ClientNavMenu";
const ClientLogin = () => {
	const [tracking, setTracking] = useState(
		localStorage.getItem("tracking") || ""
	);
	const fetchAndShowNotifications = (companyId, isEnt) => {
		PublicGet(Url.countCompanyNotifications(companyId, isEnt, false)).then(
			(cnt) => {
				setNav.notification(cnt);
			}
		);
	};

	const [isRetrieving, setIsRetrieving] = useState(false); //  toggles mode
	const navigate = useNavigate();

	const onChange = (e) => {
		setTracking(e.target.value);
	};

	const send = () => {
		const trimmedTracking = tracking.trim().toUpperCase();

		if (!trimmedTracking) {
			toast.error(
				isRetrieving
					? "Please enter your email"
					: "Please enter a tracking code"
			);
			return;
		}

		//  Handle "Retrieve company code" mode
		if (isRetrieving) {
			PublicGet(Url.public.getCompanyTrackingCode(trimmedTracking))
				.then(() => {
					toast.success("Company code sent to your email!");
					setIsRetrieving(false); // revert to normal mode
					setTracking("");
				})
				.catch(() =>
					toast.error("Unable to send company code. Please try again.")
				);
			return;
		}

		//  Normal tracking mode
		if (
			trimmedTracking.startsWith("MRT") ||
			trimmedTracking.startsWith("ENT")
		) {
			PublicGet(Url.public.getCompanyIdByTrackingCode(trimmedTracking))
				.then((resp) => {
					User.setCompany(resp);
					toast.success("Verification successful");
					toast.info(
						"NOTE : The dashboard chart data shown is monthly. You can filter by month to view specific data.",
						{
							position: "top-center", 
							autoClose: false, 
							closeOnClick: true, 
							draggable: false, 
							hideProgressBar: true, 
							closeButton: true,
							pauseOnHover: true, 
						}
					);

					navigate("/Client", {
						state: { tracking: trimmedTracking, companyId: resp.id },
					});
					if (trimmedTracking.startsWith("MRT")) {
						fetchAndShowNotifications(resp.id, false);
					} else {
						fetchAndShowNotifications(resp.id, true);
					}
				})
				.catch(() => toast.error("Invalid Company Code"));
			return;
		}

		//  Task tracking code
		PublicGet(Url.taskByTracking(trimmedTracking))
			.then((resp) => {
				localStorage.setItem("tracking", trimmedTracking);
				navigate("../ClientMilestones", {
					state: { ...resp, showLeftPanel: true },
				});
				toast("Verification Successful");
			})

			.catch((err) => {
				console.log(err);
				const message =
					err?.response?.data?.errors?.error ||
					err?.response?.data?.NoElement ||
					"Verification failed";
				toast.error(message);
			});
	};

	return (
		<div className="Login-Page">
			<div className="Login-Left">
				<div>
					<img src={logo} alt="logo" />
				</div>

				<div className="Task-Tracking">
					<Zoom>
						<h1 className="Login-Title">
							{isRetrieving
								? "Retrieve Your Company Code"
								: "Track Your Task Progress in Real-Time"}
						</h1>
					</Zoom>

					<p className="Login-Text">
						{isRetrieving
							? "Enter your registered email address and we’ll send your company code to your inbox."
							: "Enter your unique Task Number or Company Code in the input field below to monitor the status of your tasks and get real-time updates."}
					</p>

					<div className="Login-Form">
						<TextField
							onChange={onChange}
							value={tracking}
							type={isRetrieving ? "email" : "text"}
							placeholder={
								isRetrieving
									? "Enter your email"
									: "Enter tracking code or company code"
							}
						/>

						<Button className="Button" onClick={send}>
							{isRetrieving ? "Send" : "Track your Task"}
						</Button>
					</div>
				</div>

				<p
					className="Retrieve-Text"
					onClick={() => {
						setIsRetrieving(!isRetrieving);
						setTracking("");
					}}
				>
					{isRetrieving
						? "Back to task tracking"
						: "Retrieve your company code"}
				</p>
			</div>
			<div className="Login-Right"></div>
		</div>
	);
};

export default ClientLogin;
